/**
 * Intake app — /apps/intake/*
 *
 * One job: a team wants one mouth for ideas instead of five channels — and
 * submitters want to see what happened. Three screens (C Mode):
 *   /              Drop — capture in 30 seconds (AI shapes it, a human accepts)
 *   /queue         Queue — triage what came in (pursue / defer / reject)
 *   /mine          Mine — what happened to what I submitted
 *
 * All writes go through the canonical items + triage stores. No new schema.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import DropScreen from './DropScreen';
import IntakeQueueScreen from './IntakeQueueScreen';
import MySubmissionsScreen from './MySubmissionsScreen';

export default function IntakeApp() {
  const app = getAppDefinition('intake')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<DropScreen />} />
        <Route path="queue" element={<IntakeQueueScreen />} />
        <Route path="mine" element={<MySubmissionsScreen />} />
        <Route path="*" element={<Navigate to="/apps/intake" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
